module.exports = __webpack_public_path__ + "static/media/quitting_time.b6e8ed7d.svg";